import api from './api';

export default {
  getPromotion: () => api.get('promotions/getPromotion'),
  getActivePointsBackPromotion: (communityId) => api.get(`pointsBackPromotions/${communityId}`),
};
